import React, { useState } from 'react';
import { DB } from '../../data/database';
import { getContact, getPageContent } from './websiteStyles';

const DARK = '#14161C';
const PAPER = '#FAFAF8';
const INK = '#14161C';
const INK2 = '#52545C';
const INK3 = '#8B8D94';
const INK4 = '#B0B2B8';
const LINE = '#E5E5E3';
const BLUE = '#2563EB';
const GREEN = '#22C55E';
const heading = '"Inter Tight", sans-serif';
const mono = '"JetBrains Mono", monospace';

function WebsiteContact() {
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 600;
  const c = getContact();
  const cms = getPageContent('website_contact') || {};
  const [form, setForm] = useState({ name: '', phone: '', email: '', subject: 'General inquiry', message: '' });
  const [sent, setSent] = useState(false);

  const set = (key, val) => setForm(prev => ({ ...prev, [key]: val }));

  const handleSend = () => {
    if (!form.name.trim()) { alert('Please enter your name.'); return; }

    // Auto-create inquiry in the system
    try {
      const inquiries = DB.get('inquiries') || [];
      const newInq = {
        id: 'INQ-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6),
        customer_name: form.name.trim(),
        customer_phone: form.phone,
        customer_email: form.email,
        subject: form.subject || 'Website inquiry',
        message: form.message,
        channel: 'website_form',
        source: 'website_contact',
        status: 'new',
        priority: 'normal',
        messages: form.message ? [{ id: Date.now().toString(36), from: 'customer', text: form.message, channel: 'website_form', timestamp: new Date().toISOString() }] : [],
        message_count: form.message ? 1 : 0,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      };
      DB.set('inquiries', [...inquiries, newInq]);
    } catch {}

    setSent(true);
    setForm({ name: '', phone: '', email: '', subject: 'General inquiry', message: '' });
  };

  const labelStyle = { fontFamily: heading, fontSize: 13, fontWeight: 600, color: INK, marginBottom: 6, display: 'block' };
  const inputStyle = { width: '100%', height: 44, padding: '0 14px', borderRadius: 8, border: `1px solid ${LINE}`, background: '#fff', fontFamily: heading, fontSize: 14, color: INK, outline: 'none', boxSizing: 'border-box', transition: 'border-color 0.2s' };

  return (
    <div>
      {/* Header */}
      <section style={{ maxWidth: 1440, margin: '0 auto', padding: '48px 24px 0' }}>
        <div style={{ fontFamily: mono, fontSize: 10, letterSpacing: '0.14em', textTransform: 'uppercase', color: BLUE, marginBottom: 8, display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ width: 5, height: 5, borderRadius: '50%', background: BLUE }}></span>
          {cms.hero?.eyebrow || 'Contact'}
        </div>
        <h1 style={{ fontFamily: heading, fontWeight: 700, letterSpacing: '-0.04em', fontSize: 'clamp(36px, 6vw, 60px)', lineHeight: 1, color: INK }}>
          {cms.hero?.heading || 'Get in touch.'}
        </h1>
      </section>

      {/* Main content */}
      <section style={{ maxWidth: 1440, margin: '0 auto', padding: '40px 24px 80px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1.2fr 1fr', gap: isMobile ? 24 : 48, alignItems: 'flex-start' }} className="ws-contact-grid">
          {/* Left — Form */}
          <div>
            <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 16, marginBottom: 16 }}>
              <div>
                <label style={labelStyle}>Full name</label>
                <input value={form.name} onChange={e => set('name', e.target.value)} placeholder="Ahmad Al Mansouri" style={inputStyle}
                  onFocus={e => { e.target.style.borderColor = BLUE; }} onBlur={e => { e.target.style.borderColor = LINE; }} />
              </div>
              <div>
                <label style={labelStyle}>Phone</label>
                <input value={form.phone} onChange={e => set('phone', e.target.value)} placeholder="+971 50 XXX XXXX" style={inputStyle}
                  onFocus={e => { e.target.style.borderColor = BLUE; }} onBlur={e => { e.target.style.borderColor = LINE; }} />
              </div>
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={labelStyle}>Email</label>
              <input value={form.email} onChange={e => set('email', e.target.value)} placeholder="you@example.com" type="email" style={inputStyle}
                onFocus={e => { e.target.style.borderColor = BLUE; }} onBlur={e => { e.target.style.borderColor = LINE; }} />
            </div>
            <div style={{ marginBottom: 16 }}>
              <label style={labelStyle}>Subject</label>
              <select value={form.subject} onChange={e => set('subject', e.target.value)} style={{ ...inputStyle, cursor: 'pointer', appearance: 'none', WebkitAppearance: 'none' }}>
                <option>General inquiry</option>
                <option>Vehicle pricing</option>
                <option>Spare parts quote</option>
                <option>Shipping & logistics</option>
                <option>Trade account</option>
                <option>Other</option>
              </select>
            </div>
            <div style={{ marginBottom: 24 }}>
              <label style={labelStyle}>Message</label>
              <textarea value={form.message} onChange={e => set('message', e.target.value)} placeholder="Tell us what you're looking for..."
                rows={5} style={{ ...inputStyle, height: 'auto', padding: '12px 14px', resize: 'vertical', lineHeight: 1.6 }}
                onFocus={e => { e.target.style.borderColor = BLUE; }} onBlur={e => { e.target.style.borderColor = LINE; }} />
            </div>
            <button onClick={handleSend} disabled={sent} style={{
              display: 'inline-flex', alignItems: 'center', gap: 8, padding: '14px 28px', borderRadius: 9999,
              background: sent ? GREEN : INK, color: '#fff', fontFamily: heading, fontSize: 14, fontWeight: 600,
              border: 'none', cursor: sent ? 'default' : 'pointer', transition: 'background 0.2s',
            }}>
              {sent ? '✓ Thank you! We\'ll get back within 24 hours.' : 'Send message →'}
            </button>
          </div>

          {/* Right — Info cards */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {/* WhatsApp card */}
            <a href={`https://wa.me/${c.whatsapp}`} target="_blank" rel="noopener noreferrer"
              style={{ display: 'block', background: DARK, borderRadius: 16, padding: 28, textDecoration: 'none', transition: 'transform 0.2s' }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = ''; }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
                <svg viewBox="0 0 24 24" fill="#25D366" style={{ width: 28, height: 28 }}>
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                  <path d="M12 0C5.373 0 0 5.373 0 12c0 2.625.846 5.059 2.284 7.034L.789 23.492a.5.5 0 00.612.616l4.529-1.476A11.96 11.96 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22a9.94 9.94 0 01-5.33-1.543l-.372-.225-2.688.877.858-2.63-.248-.393A9.96 9.96 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
                </svg>
                <span style={{ fontFamily: heading, fontSize: 22, fontWeight: 700, color: PAPER }}>{cms.whatsapp?.heading || 'WhatsApp us'}</span>
              </div>
              <p style={{ fontSize: 14, color: 'rgba(250,250,248,0.45)', lineHeight: 1.6, marginBottom: 16 }}>
                {cms.whatsapp?.description || 'Fastest way to reach a sales rep — typical response under 5 min.'}
              </p>
              <span style={{ display: 'inline-block', padding: '10px 20px', borderRadius: 9999, background: '#25D366', color: '#fff', fontFamily: heading, fontSize: 13, fontWeight: 600 }}>
                +{c.whatsapp}
              </span>
            </a>

            {/* Sharjah HQ */}
            <div style={{ background: '#fff', borderRadius: 12, border: `1px solid ${LINE}`, padding: 20, display: 'flex', alignItems: 'center', gap: 14 }}>
              <div style={{ width: 40, height: 40, borderRadius: 10, background: PAPER, display: 'grid', placeItems: 'center', flexShrink: 0 }}>
                <svg viewBox="0 0 24 24" fill="none" stroke={INK} strokeWidth="1.5" style={{ width: 20, height: 20 }}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
              </div>
              <div>
                <div style={{ fontFamily: heading, fontSize: 15, fontWeight: 600, color: INK }}>Sharjah HQ</div>
                <div style={{ fontSize: 13, color: INK3, marginTop: 2 }}>{c.address}</div>
              </div>
            </div>

            {/* Sales line */}
            <a href={`tel:${c.phone}`} style={{ background: '#fff', borderRadius: 12, border: `1px solid ${LINE}`, padding: 20, display: 'flex', alignItems: 'center', gap: 14, textDecoration: 'none', color: INK }}>
              <div style={{ width: 40, height: 40, borderRadius: 10, background: PAPER, display: 'grid', placeItems: 'center', flexShrink: 0 }}>
                <svg viewBox="0 0 24 24" fill="none" stroke={INK} strokeWidth="1.5" style={{ width: 20, height: 20 }}><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
              </div>
              <div>
                <div style={{ fontFamily: heading, fontSize: 15, fontWeight: 600, color: INK }}>Sales line</div>
                <div style={{ fontSize: 13, color: INK3, marginTop: 2 }}>{c.phone} · 8AM-9PM</div>
              </div>
            </a>

            {/* Email */}
            <a href={`mailto:${c.email}`} style={{ background: '#fff', borderRadius: 12, border: `1px solid ${LINE}`, padding: 20, display: 'flex', alignItems: 'center', gap: 14, textDecoration: 'none', color: INK }}>
              <div style={{ width: 40, height: 40, borderRadius: 10, background: PAPER, display: 'grid', placeItems: 'center', flexShrink: 0 }}>
                <svg viewBox="0 0 24 24" fill="none" stroke={INK} strokeWidth="1.5" style={{ width: 20, height: 20 }}><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              </div>
              <div>
                <div style={{ fontFamily: heading, fontSize: 15, fontWeight: 600, color: INK }}>Email</div>
                <div style={{ fontSize: 13, color: INK3, marginTop: 2 }}>{c.email}</div>
              </div>
            </a>
          </div>
        </div>
      </section>

      <style>{`
        @media (max-width: 768px) {
          .ws-contact-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </div>
  );
}

export default WebsiteContact;
